import React from 'react';
import moment from 'moment';
import Typography from '@material-ui/core/Typography';
import ReactTable from 'react-table-v6'
import '../../assets/css/Order.css'
import Pdf from '../../assets/img/pdf_icon.png';
import Img from '../../assets/img/image_icon.jpg';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import axios from 'axios'
import CardContent from '@material-ui/core/CardContent';
import Grid from '@material-ui/core/Grid'
import Card from "../Card/Card.jsx";
import RegularButton from "../../components/CustomButtons/Button.jsx";
import CondensedNotes from "../Common/CondensedNotes.jsx";
import { BASE_URL } from '../../utils/handleApi';

const useStyles = (theme) => ({
    rootButton: {
        '& > *': {
            margin: theme.spacing(1),
            marginTop: theme.spacing(-1.8),
            marginLeft: theme.spacing(1.5)
        }
    },
    paper: {
        backgroundColor: "red"
    },
    margin: {
        marginRight: theme.spacing(10)
    },
    textField: {
        width: '14em',
    },
    inputUpload: {
        color: '#AAAAAA',
        fontFamily: 'Roboto-Medium',
        [theme.breakpoints.down('xs')]: {
            width: "70%"
        }
    },
    inputRoot: {
        '& > *': {
            margin: theme.spacing(1),
            width: '25ch',
        },
    },
    textInput: {
        borderBottom: '1px solid red'
    },
    pdfIcon: {
        width: "7%",
        height: "7%",
        [theme.breakpoints.down('md')]: {
            fontSize: '22px',
        },
        [theme.breakpoints.down('xs')]: {
            width: "10%",
        },
    },
    orderUpdatesIcon: {
        width: "4%",
        height: "4%",
        [theme.breakpoints.down('md')]: {
            fontSize: '22px',
        },
        [theme.breakpoints.down('xs')]: {
            width: "10%",
        },
    },
    pdfText: {
        margin: '0 0 0 1em',
        color: '#04ab23',
        fontFamily: "Roboto-Regular",
        textOverflow: 'ellipsis',
        maxWidth: '20vw',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        [theme.breakpoints.only('sm')]: {
            maxWidth: '40vw',
        },
        [theme.breakpoints.only('xs')]: {
            maxWidth: '45vw',
        },
    },
    updateText: {
        margin: '0 0 0 1em',
        color: '#04ab23',
        fontFamily: "Roboto-Regular",
        overflow: 'hidden',
        [theme.breakpoints.only('sm')]: {
            maxWidth: '40vw',
        },
        [theme.breakpoints.only('xs')]: {
            maxWidth: '45vw',
        },
    },
    hintText: {
        display: 'flex',
        justifyContent: 'flex-start',
        [theme.breakpoints.only('xs')]: {
            justifyContent: 'center',
        },
    },
    pin: {
        [theme.breakpoints.down('xs')]: {
            marginRight: "10px"
        }
    },
    orderInfoTable: {
        border: 'none',
        marginLeft: '2.5em',
        [theme.breakpoints.down('xs')]: {
            margin: 0,
        }
    },
    lenderInfoTable: {
        border: 'none',
        marginLeft: '2.5em',
        [theme.breakpoints.down('xs')]: {
            margin: 0,
        }
    },
    resDataTable: {
        border: 'none',
        marginLeft: '2.5em',
        [theme.breakpoints.down('xs')]: {
            margin: 0,
        }
    },
    attachmentTable: {
        width: 'auto',
        marginLeft: '2.5em',
        [theme.breakpoints.down('xs')]: {
            margin: 0,
        }
    },
    orderUpdatesTable: {
        width: 'auto',
        marginLeft: '2.5em',
        [theme.breakpoints.down('xs')]: {
            margin: 0,
        }
    },
    uploadLabel: {
        color: '#aaa', 
        fontFamily: 'Roboto-Bold',
        [theme.breakpoints.down('xs')]: {
            textAlign: 'center',
            marginTop: '1em',
        }
    },
    input_field: {
        [theme.breakpoints.down('xs')]: {
            maxWidth: '240px'
        }
    },
    input_div: {
        [theme.breakpoints.down('xs')]: {
           textAlign: 'center'
        }
    },
    notesButton: {
        [theme.breakpoints.only('xs')]: {
            textAlign: 'center'
         }
    },
    uploadAttachmentBtton: {
        [theme.breakpoints.down('sm')]: {
            marginTop: '20px !important'
         }
    }
});
class Detailstable extends React.Component {

    constructor(props) {
        super(props)
        this.fileInput = React.createRef();
        this.state = {
            response_input: [],
            OrderInfodata : [],
            ClientInfodata : [],
            order_data: {},
            attachments: [],
            notesData: [],
            notes: "",
            orderUpdatesData: [],
        }
    }

    handleChange = (event) => {
        const { response_input } = this.state;
        event.preventDefault();

        if(event.target.id === "notes"){
            return this.setState({ notes: event.target.value})
        }
        var arrResponses = response_input
        var dict = arrResponses[event.target.getAttribute('data-order')]

        dict["output_data"] = event.target.value
        arrResponses[event.target.getAttribute('data-order')] = dict

        this.setState({ response_input : arrResponses })
    };

    componentDidMount() {
        this.loadDocuments();
    }

    loadDocuments = () => {
        this.fileInput.value = "";
        let tokenStr = localStorage.getItem('token')
        const options = {
            headers: { 'Authorization': `Bearer ${tokenStr}` }
        };
        const body = {
            order_id: this.props.orderId 
        }
        axios.post(`${BASE_URL}/order/orderDetails`, body, options)
        .then((res) => {
            if (res.data.order_response != null) {
                this.setState({ response_input: res.data.order_response })
            }
            if (res.data.attachments != null) {
                this.setState({ attachments: res.data.attachments.order_attachments })
            }
            if (res.data.order_updates != null) {
                this.setState({ orderUpdatesData: res.data.order_updates.order_updates })
            }
            const vendorEmail = localStorage.getItem('vendor_email')
            if(res.data.notes !== null){
                const notesData = res.data.notes?.order_notes.map(note => {
                    return { 
                        date: moment(note.done_on).format('MM/DD/YYYY hh:mmA'), 
                        name: vendorEmail, 
                        content: note.notes 
                    }
                })
                this.setState({ notesData })
            }
            this.setState({ order_data : res.data})
            const completedDate = res.data?.logs?.order_status.filter(order_stat => order_stat.status === "Completed")[0]?.done_on

            var info_data = [
                { id: "Order Number", name: res.data.order_no },
                { id: "Order Date", name: moment(res.data.order_date).format('MM/DD/YYYY') },
                { id: "Due Date", name: <p style={{ color: '#EE3F34', fontFamily: 'Roboto-Medium', margin: 0 }}>{moment(res.data.due_date).format('MM/DD/YYYY')}</p> },
                { id: "Completed Date", name: completedDate !== undefined ? moment(completedDate).format('MM/DD/YYYY') : "N/A" },
                { id: res.data.borrower?.name 
                    ? "Borrower Name" 
                    : "Borrower Business Name",
                    name: res.data.borrower?.name 
                    ? res.data.borrower?.name 
                    : res.data.borrower?.business_name
                },
                { id: "Street", name: res.data.location?.street_address},
                { id: "City, State, ZIP", name: `${res.data.location?.city}, ${res.data.location?.state}, ${res.data.location?.zip}`},
                { id: "Product", name: res.data?.search_products_type?.name || "N/A" },
                { id: "Special Instruction", name: res.data.instructions },
                { id: "Order Reference", name: res.data.order_ref },
                { id: "Parcel", name: res.data.parcel },
                { id: "Requester Email Address", name: res.data.requester_email_address },
                { id: "Requester Name", name: res.data.requester_name },
            ]

            var client_info_data =  [
                    { id: "Client", name: res.data.lender_id?.name },
                    { id: "ID", name: res.data.lender_id?.client_no},
                    { id: "Contact", name: res.data.lender_id?.billing_contact },
                    { id: "Street ", name: res.data.lender_id?.street },
                    { id: "City, State, ZIP", name: `${res.data.lender_id?.city}, ${res.data.lender_id?.state}, ${res.data.lender_id?.zip}` },
                ]

            this.setState({ 
                    OrderInfodata: info_data, 
                    ClientInfodata: client_info_data,
                })
            })
        .catch((err) => {})
    }

    addNotes = () => {
        let tokenStr = localStorage.getItem('token')
        const options = {
            headers: { 'Authorization': `Bearer ${tokenStr}` }
        };
        const vendor_data = JSON.parse(localStorage.getItem('vendor_data'))
        const body = {
            order_id: this.props.orderId,
            lender_id: this.state.order_data.lender_id._id,
            vendor_id: vendor_data.id,
            vendor_name: vendor_data.name,
            notes: this.state.notes,
            credential_id: localStorage.getItem('vendor_credential_id')
        }
        axios.post(`${BASE_URL}/order/addNotes`, body, options)
        .then(res => {
            this.loadDocuments();
            this.setState({ notes: "" })
        })
        .catch(err => {})
    }

    render() {
        const { classes } = this.props;
        const { OrderInfodata, ClientInfodata, response_input, order_data, attachments, notesData, notes, orderUpdatesData } = this.state;
        return (
            <div style={{ width: '85vw', margin: 'auto', backgroundColor: 'white' }}>
                <Grid container>
                    <Grid item xs={12} md={6}>
                        <div style={{ width: '95%' }}>
                            <Card style={{ height: 'auto', boxShadow: '0px 0px 5px 0px #d6d6d6' }} >
                                <div className={classes.rootButton}>
                                    <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA', fontSize: '13.9px', outline: 'none', color: 'white', height: '47px', width: '168px', borderRadius: 2, fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                        Order Information
                                    </Button>
                                </div>
                                <CardContent>
                                    <ReactTable
                                        data={
                                            OrderInfodata.map((prop, key) => ({
                                                id: prop.id,
                                                name: prop.name,
                                            }))
                                        }
                                        columns={[
                                            {
                                                accessor: 'id',
                                                headerStyle: { border: 'none' },
                                                style: { border: 'none', color: '#AAAAAA', fontFamily: 'Roboto-Bold', },
                                                width: 180,
                                            },
                                            {
                                                accessor: 'name',
                                                style: { fontFamily: 'Roboto-Regular', color: '#888888' }
                                            },

                                        ]}
                                        showPaginationBottom={false}
                                        defaultPageSize={13}
                                        sortable={false}
                                        className={classes.orderInfoTable}
                                        getTrGroupProps={() => {
                                            return {
                                                style: {
                                                    border: "0px",
                                                    backgroundColor: 'white',
                                                }
                                            }
                                        }}
                                    />
                                </CardContent>

                            </Card>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <div style={{ width: '95%', marginLeft: '1%' }}>
                            <Card style={{ height: 'auto', boxShadow: '0px 0px 5px 0px #d6d6d6' }}>
                                <div className={classes.rootButton}>
                                    <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA', outline: 'none', color: 'white', fontSize: '13.9px', height: '47px', width: '168px', borderRadius: 2, fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                        Lender Information
                                    </Button>
                                </div>
                                <CardContent>
                                    <ReactTable
                                        data={ClientInfodata.map((props, key) => {
                                                return {
                                                    id: props.id,
                                                    name: props.name,
                                                }
                                            })
                                        }
                                        columns={[
                                            {
                                                accessor: 'id',
                                                style: { border: 'none', color: '#AAAAAA', fontFamily: 'Roboto-Bold' },
                                                headerStyle: { border: 'none' },
                                                width: 120
                                            },
                                            {
                                                accessor: 'name',
                                                style: { fontFamily: 'Roboto-Regular', color: '#888888', fontWeight: 'bolder' }
                                            },

                                        ]}
                                        showPaginationBottom={false}
                                        defaultPageSize={5}
                                        sortable={false}
                                        className={classes.lenderInfoTable}
                                        getTrGroupProps={() => {
                                            return {
                                                style: {
                                                    border: "0px",
                                                    backgroundColor: 'white'
                                                }
                                            }
                                        }}
                                    />
                                </CardContent>
                            </Card>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <div style={{ width: '95%' }}>
                            <Card style={{ height: 'auto', boxShadow: '0px 0px 5px 0px #d6d6d6' }}>
                                <div className={classes.rootButton}>
                                    <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA', outline: 'none', color: 'white', fontSize: '14px', height: '47px', width: '187.5px', borderRadius: 2, fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                        Response Data Input
                                    </Button>
                                </div>
                                <CardContent>
                                    <ReactTable
                                        NoDataComponent={() => <p style={{textAlign: "center", margin: 0, color: "#999"}}>No Data</p>}
                                        data={response_input.map((props, key) => ({
                                            id: props.input_data,
                                            name: (
                                                <input 
                                                    value={props.output_data}
                                                    disabled={this.props.comp_order}
                                                    style={{ border: "none", borderBottom: "1px solid gray" }} 
                                                    onChange = {e => this.props.handleResponseInput(e, response_input)}
                                                    data-order = {key}
                                                />)
                                            })
                                        )}
                                        columns={[
                                            {
                                                accessor: 'id',
                                                style: { border: 'none', color: '#AAAAAA', fontFamily: 'Roboto-Bold' },
                                                headerStyle: { border: 'none' },
                                                width: 180
                                            },
                                            {
                                                accessor: 'name',
                                                style: { fontFamily: 'Roboto-Regular', color: 'white', fontWeight: 'bolder' }
                                            },

                                        ]}
                                        showPaginationBottom={false}
                                        defaultPageSize={10}
                                        minRows={0}
                                        sortable={false}
                                        className={classes.resDataTable}
                                        getTrGroupProps={() => {
                                            return {
                                                style: {
                                                    border: "0px",
                                                    backgroundColor: "white"

                                                }
                                            }
                                        }}
                                    />
                                </CardContent>
                            </Card>
                        </div>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <div style={{ width: '95%', marginLeft: '1%' }}>
                            <Card style={{ height: 'auto', boxShadow: '0px 0px 5px 0px #d6d6d6'}}>
                                <div className={classes.rootButton}>
                                    <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA', outline: 'none', color: 'white', fontSize: '14px', height: '47px', width: '187.5px', borderRadius: 2, fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                        Upload Attachments
                                    </Button>
                                </div>
                                <CardContent>
                                    <Grid container className={classes.attachmentTable}>
                                        {attachments.slice(0,15).map((attachment, id) => {
                                            return <Grid key={id} container style={{ display: 'flex', alignItems: 'center',
                                            justifyContent: 'space-between', marginBottom: '1em' }}>
                                                <Grid item xs={3} sm={4}>
                                                    <p style={{ color: '#aaa', fontFamily: 'Roboto-Bold', margin: 0 }}>
                                                        File {id + 1}
                                                    </p>
                                                </Grid>
                                                <Grid item xs={9} sm={8}>
                                                    <div style={{ display: 'flex', alignItems: 'center' }}>
                                                        {attachment.link.endsWith("pdf") 
                                                            ? <img src={Pdf} alt="Pdf" className={classes.pdfIcon} />
                                                            : <img src={Img} alt="Img" className={classes.pdfIcon} />
                                                        }
                                                        <a 
                                                            href={attachment.link} 
                                                            target="_blank" 
                                                            rel="noopener noreferrer">
                                                            <p className={classes.pdfText}>
                                                                {attachment.link.slice(52)}
                                                            </p>
                                                        </a>
                                                    </div>
                                                </Grid>
                                            </Grid>})}
                                        <Grid container>
                                            <Grid item xs={12} sm={4}>
                                                <p className={classes.uploadLabel}>
                                                    Upload
                                                </p>
                                            </Grid>
                                            <Grid item xs={12} sm={8} className={classes.input_div}>
                                                <input 
                                                    type="file"
                                                    id="attachments"
                                                    capture
                                                    onChange={e => this.props.handleFileChange(e, order_data.lender_id._id)}
                                                    ref={ref => this.fileInput = ref}
                                                    accept=".pdf, image/*"
                                                    disabled={this.props.comp_order || attachments.length >= 15}
                                                    className={classes.input_field}
                                                />
                                            </Grid>
                                            {!this.props.comp_order && <>
                                                <Grid item xs={12} sm={4}></Grid>
                                                <Grid item xs={12} sm={8} className={classes.hintText}>
                                                    <Typography variant="caption">
                                                        (Only 15 attachments allowed!)
                                                    </Typography>
                                                </Grid>
                                            </>}
                                        </Grid>
                                    </Grid>
                                </CardContent>
                            </Card>
                        </div>
                    </Grid>

                    <Grid item xs={12}>
                        <div style={{ width: '95%' }}>
                            <Card style={{ height: 'auto', boxShadow: '0px 0px 5px 0px #d6d6d6' }}>
                                <div className={classes.rootButton}>
                                    <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA', outline: 'none', color: 'white', fontSize: '14px', height: '47px', width: '187.5px', borderRadius: 2, fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                        Notes
                                    </Button>
                                </div>
                                <CardContent>
                                    <Grid container style={{alignItems: 'center'}}>
                                        <Grid item xs={12} md={9} style={{ flexGrow: 1 }}>
                                            <textarea 
                                                style={{ width: '100%', padding: '5px' }} 
                                                placeholder="Add your note here..."
                                                rows={3}
                                                value={notes}
                                                onChange={this.handleChange}
                                                id="notes"
                                            />
                                        </Grid>
                                        <Grid item xs={12} md={3} className={classes.notesButton} style={{textAlign: 'center'}}>
                                            <RegularButton 
                                                onClick={this.addNotes}
                                                disabled={!notes || notes.trim() === ""}
                                                variant="contained" 
                                                style={{ fontSize: '20px', borderRadius: 1, fontFamily: 'Roboto-Regular', outline: 'none', color: 'white', backgroundColor: '#04ab23', 
                                                width: '7em', textTransform: 'none', verticalAlign: "middle", margin: "0 1em" }}>
                                                    Add
                                            </RegularButton>
                                        </Grid>
                                    </Grid>
                                    <ReactTable
                                        NoDataComponent={() => <p style={{textAlign: "center"}}>{ !this.props.comp_order ? "" : "No Notes Available"}</p>}
                                        data={notesData !== undefined ? notesData.map((props) => ({
                                            id: props.date,
                                            name: props.name,
                                            data: props.content
                                        })) : []}
                                        columns={[
                                            {
                                                accessor: 'id',
                                                Header: 'Added On',
                                                style: { fontFamily: 'Roboto-Bold', border: 'none', color: '#999', textAlign: 'center' },
                                                headerStyle: { border: 'none', display: notesData !== undefined ? 'block' : 'none', textAlign: 'center' },
                                                width: 180
                                            },
                                            {
                                                accessor: 'name',
                                                Header: 'User Name',
                                                headerStyle: { border: 'none', display: notesData !== undefined ? 'block' : 'none', textAlign: 'center' },
                                                style: { fontFamily: 'Roboto-Bold', border: 'none', color: '#666', textAlign: 'center' },
                                                width: 250
                                            },
                                            {
                                                accessor: 'data',
                                                Header: 'Content',
                                                Cell: row => <CondensedNotes row={row} slicedIndex={200} />,
                                                headerStyle: { border: 'none', display: notesData !== undefined ? 'block' : 'none', textAlign: 'left' },
                                                style: { fontFamily: 'Roboto-Bold', border: 'none', color: '#333', whiteSpace: 'normal' }
                                            },
                                        ]}
                                        showPaginationBottom={false}
                                        defaultPageSize={10}
                                        minRows={0}
                                        sortable={false}
                                        style={{border: 'none'}}
                                        getTrGroupProps={() => {
                                            return {
                                                style: {
                                                    border: "0px",
                                                    backgroundColor: "white"
                                                }
                                            }
                                        }}
                                    />
                                </CardContent>
                            </Card>
                        </div>
                    </Grid>

                    {this.props.comp_order && (
                        <Grid item xs={12}>
                            <div style={{ width: '95%' }}>
                                <Card style={{ height: 'auto', boxShadow: '0px 0px 5px 0px #d6d6d6' }}>
                                    <div className={classes.rootButton}>
                                        <Button variant="contained" style={{ boxShadow: '0px 3px 5px -2px #AAAAAA', outline: 'none', color: 'white', fontSize: '14px', height: '47px', width: '187.5px', borderRadius: 2, fontFamily: 'Roboto-Bold', backgroundColor: '#04AB23', textTransform: 'none' }} disabled>
                                            Order Updates
                                        </Button>
                                    </div>
                                    <CardContent>
                                        <Grid container className={classes.attachmentTable}>
                                            {orderUpdatesData.slice(0,15).map((order_update, id) => {
                                                return <Grid container key={id} style={{ display: 'flex', alignItems: 'center',
                                                justifyContent: 'space-between', marginBottom: '1em' }}>
                                                    <Grid item xs={3} sm={4}>
                                                        <p style={{ color: '#aaa', fontFamily: 'Roboto-Bold', margin: 0 }}>
                                                            File {id + 1}
                                                        </p>
                                                    </Grid>
                                                    <Grid item xs={1}></Grid>
                                                    <Grid item xs={8} sm={7}>
                                                        <div style={{ display: 'flex', alignItems: 'center' }}>
                                                            {order_update.link.endsWith("pdf")
                                                                ? <img src={Pdf} alt="Pdf" className={classes.orderUpdatesIcon} />
                                                                : <img src={Img} alt="Img" className={classes.orderUpdatesIcon} />
                                                            }
                                                            <a 
                                                                href={order_update.link} 
                                                                target="_blank" 
                                                                rel="noopener noreferrer">
                                                                <p className={classes.updateText}>
                                                                    {order_update.link.slice(52)}
                                                                </p>
                                                            </a>
                                                        </div>
                                                    </Grid>
                                            </Grid>})}
                                            <Grid container style={{alignItems: 'center'}}>
                                                <Grid item xs={12} md={9} style={{ flexGrow: 1 }}>
                                                    <Grid>
                                                        <input 
                                                            type="file"
                                                            id="order_updates"
                                                            ref={ref => this.fileInput = ref}
                                                            onChange={e => this.props.handleFileChange(e, order_data.lender_id._id)}
                                                            accept=".pdf, image/*"
                                                            disabled={orderUpdatesData.length >= 15}
                                                        />
                                                        <Grid item xs={12} md={9} className={classes.hintText} style={{marginTop: '5px'}}>
                                                            <Typography variant="caption">
                                                                (Only 15 updates allowed!)
                                                            </Typography>
                                                        </Grid>
                                                    </Grid>
                                                </Grid>
                                                
                                                <Grid item xs={12} md={3} className={classes.notesButton} style={{textAlign: 'right'}}>
                                                    <RegularButton 
                                                        onClick={this.props.uploadOrderAttachments}
                                                        disabled={orderUpdatesData.length >= 15}
                                                        variant="contained"
                                                        className={classes.uploadAttachmentBtton}
                                                        style={{ fontSize: '20px', borderRadius: 1, fontFamily: 'Roboto-Regular', outline: 'none', 
                                                        color: 'white', backgroundColor: '#04ab23', 
                                                        width: '10em', textTransform: 'none', verticalAlign: "middle", margin: "0 1em" }}>
                                                            Send Order Update
                                                    </RegularButton>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>
                            </div>
                        </Grid>
                    )}
                </Grid>
            </div>
        )
    }
}
export default withStyles(useStyles, { withTheme: true })(Detailstable)

